var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.674,
    height: 92.614,
    viewBox: "0 0 92.674 92.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success_check",
    transform: "translate(0 -0.168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 46.337,
    cy: 46.307,
    rx: 46.337,
    ry: 46.307,
    transform: "translate(0 0.168)",
    fill: "#32bea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8959",
    "data-name": "Path 8959",
    d: "M136.341,181.126l-21.909-17.068,6.229-7.995,13.454,10.481,22.2-32.041,8.332,5.772Z",
    transform: "translate(-93.719 -110.021)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success_check.ba503946a2f869cb227398e4ae623f39.svg";
export { ForwardRef as ReactComponent };